import {
  __objRest,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/list/list.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var UnorderedList = forwardRef(
  (_a, ref) => {
    var _b = _a, { size = "default", className } = _b, rest = __objRest(_b, ["size", "className"]);
    return /* @__PURE__ */ jsx(
      "ul",
      __spreadValues({
        ref,
        className: clsx(
          "hds-list",
          size !== "default" && `hds-list--${size}`,
          className
        )
      }, rest)
    );
  }
);
UnorderedList.displayName = "UnorderedList";
var OrderedList = forwardRef(
  (_a, ref) => {
    var _b = _a, { size = "medium", className } = _b, rest = __objRest(_b, ["size", "className"]);
    return /* @__PURE__ */ jsx(
      "ol",
      __spreadValues({
        ref,
        className: clsx(
          "hds-list",
          size !== "default" && `hds-list--${size}`,
          className
        )
      }, rest)
    );
  }
);
OrderedList.displayName = "OrderedList";

export {
  UnorderedList,
  OrderedList
};
//# sourceMappingURL=chunk-3QHKPEXO.mjs.map